var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.94772 5.94772 1 12 1C18.0523 1 23 5.94772 23 12C23 18.0523 18.0523 23 12 23C5.94772 23 1 18.0523 1 12ZM12 3C7.05228 3 3 7.05228 3 12C3 16.9477 7.05228 21 12 21C16.9477 21 21 16.9477 21 12C21 7.05228 16.9477 3 12 3ZM8.5 9.40933C8.5 7.4873 10.0973 6 12 6C13.9027 6 15.5 7.4873 15.5 9.40933C15.5 10.9086 14.4823 11.6919 13.8171 12.13C13.5205 12.3275 13.319 12.4894 13.1863 12.6609C13.0734 12.8068 13 12.9721 13 13.2265V13.5312C13 14.0835 12.5523 14.5312 12 14.5312C11.4477 14.5312 11 14.0835 11 13.5312V13.2265C11 11.6931 12.0414 10.9092 12.7111 10.4636L12.7154 10.4608L12.7154 10.4608C12.9988 10.2743 13.1938 10.1159 13.3213 9.95003C13.4305 9.80803 13.5 9.64891 13.5 9.40933C13.5 8.66084 12.8684 8 12 8C11.1316 8 10.5 8.66084 10.5 9.40933C10.5 9.96162 10.0523 10.4093 9.5 10.4093C8.94772 10.4093 8.5 9.96162 8.5 9.40933ZM10.9932 17C10.9932 16.4477 11.4409 16 11.9932 16H12.0068C12.5591 16 13.0068 16.4477 13.0068 17C13.0068 17.5523 12.5591 18 12.0068 18H11.9932C11.4409 18 10.9932 17.5523 10.9932 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.6cd6a585914aefe6712fb1b7e0d30b80.svg";
export { ForwardRef as ReactComponent };